import React from 'react';

import { useI18n } from 'lib/i18n/context';

import ContractVerificationMethod from '../ContractVerificationMethod';
import ContractVerificationFieldCompiler from '../fields/ContractVerificationFieldCompiler';
import ContractVerificationFieldEvmVersion from '../fields/ContractVerificationFieldEvmVersion';
import ContractVerificationFieldLibraries from '../fields/ContractVerificationFieldLibraries';
import ContractVerificationFieldOptimization from '../fields/ContractVerificationFieldOptimization';
import ContractVerificationFieldSources from '../fields/ContractVerificationFieldSources';
import { CONTRACT_VERIFICATION_FIELD_KEYS, CONTRACT_VERIFICATION_METHOD_TITLE_KEYS } from '../i18n';

const FILE_TYPES = [ '.sol' as const, '.yul' as const ];

const ContractVerificationMultiPartFile = () => {
  const { t } = useI18n();
  return (
    <ContractVerificationMethod title={ t(CONTRACT_VERIFICATION_METHOD_TITLE_KEYS['multi-part']) }>
      <ContractVerificationFieldCompiler/>
      <ContractVerificationFieldEvmVersion/>
      <ContractVerificationFieldOptimization/>
      <ContractVerificationFieldSources
        fileTypes={ FILE_TYPES }
        multiple
        fullFilePath
        required
        title={ t(CONTRACT_VERIFICATION_FIELD_KEYS.sources.multiPartTitle) }
        hint={ t(CONTRACT_VERIFICATION_FIELD_KEYS.sources.multiPartHint) }
      />
      <ContractVerificationFieldLibraries/>
    </ContractVerificationMethod>
  );
};

export default React.memo(ContractVerificationMultiPartFile);
